import React from 'react';

interface IProps {
  title: string;
  rangeUnit?: string;
}

export default function SectionTitle({ title, rangeUnit }: IProps) {
  return (
    <div className="flex items-baseline gap-x-1 pb-2 font-semibold text-base text-primary">
      <span>{title}</span>
      {rangeUnit && <span className="text-sm text-primary">({rangeUnit})</span>}
    </div>
  );
}
